export default function Embed({record}) {
  if (!record.embedCode) {
    return null;
  }
  return (
    <div className="py-10">
      <div dangerouslySetInnerHTML={{ __html: record.embedCode }} />
    </div>
  );
}

